<template>
  <donut-chart-card
    title="안전계획 현황"
    :value="data"
    :init-total="total"
    unit="건"
    :isMoveWrite="isMoveWrite"
    :orientation="orientation"
    @detail="onClickDetail"
    @write="onClickWrite"
  ></donut-chart-card>
</template>

<script>
/* eslint-disable brace-style */
import DonutChartCard from '@/components/DonutChartCard'

export default {
  name: 'DonutChart34',
  components: {DonutChartCard},
  props: {
    dataType: 'detail' | 'field' | 'address' | 'field_cat1' | 'company' | 'project',
    orientation: {
      type: "landscape" | "portrait",
      default: () => "portrait"
    },
  },
  computed: {
    projectId () {
      return this.$route.params.proj_id
    },
    isMoveWrite () {
      // if (Number(`${this.projectId}`) === 1) return false
      // else return true
      return true
    },
    getLevel() {
      const projects = this.$store.state.member.memberInfo.projects;
      if (projects) {
        for (const project of projects) {
          if (`${project.id}` === `${this.projectId}` && project.company.length > 0) {
            const path = project.company[0].pivot.company_path;
            return path.split("/").length - 1; // Level
          }
        }
      }
    },
  },
  watch: {
    dataType () {
      this.loadGraph()
    }
  },
  data () {
    return {
      graphId: 34,
      data: [{label: '데이터 없음', value: 0}],
      total: 0,
      cache: {},
    }
  },
  async mounted () {
    await this.loadDetailData();
    await this.loadGraph()
  },
  methods: {
    async loadDetailData(currentYear, depth = -1) {
      if (!currentYear) {
        currentYear = new Date().getFullYear();
      }
      if (depth < 0) {
        depth = 1;
      }

      const cacheKey = `detail_${currentYear}_${depth}`;

      // 캐시에 저장되어 있으면, 캐시에서 불러온다
      if (this.cache[cacheKey]) {
        return JSON.parse(JSON.stringify(this.cache[cacheKey]));
      }
      // 캐시에 저장되어 있지 않으면, API에서 불러온다
      else {
        const params = {
          currentYear,
          projectIds: [this.projectId],
          // fieldCode: 'workplace-material',
          depth,
        };
        const data = await this.$store.dispatch("summary/LOAD_DONUT_34_DETAIL", params);
        this.cache[cacheKey] = data;
        return data;
      }
    },
    async loadGraph () {
      const data = await this.loadDetailData()

      let graph2Data = [];
      if (!this.projectId) {
        graph2Data = data.project;
      } else {
        switch (this.getLevel) {
        case 1:
        case 2:
          graph2Data = data.company;
          break;
        case 3:
          graph2Data = data.facilityCategory;
          break;
        case 4:
        default:
          graph2Data = data.field;
          break;
        }
      }

      const currentYear = new Date().getFullYear();
      // const currentMonth = new Date().getMonth() + 1;

      // const currentData = graph2Data[currentYear][currentMonth];

      // currentData 아이템들을 누적해서 합산한다
      const sumData = [];
      const memberInfo = this.$store.state.member.memberInfo;
      for (const monthlyData of graph2Data[currentYear]) {
        for (const projectData of monthlyData) {
          // 2024.05.02
          // https://app.clickup.com/t/86ep8969h
          // 경남도청의 경우, 조회한 사용자의 소속을 표시한다.
          let label = projectData.label;
          if (label === '경남도청' && parseInt(projectData.company_id) === parseInt(memberInfo.company_id) && memberInfo.section) {
            label = memberInfo.section;
          }
          const count = projectData.count;

          const foundRow = sumData.find((row) => row.label === label);
          if (foundRow) {
            foundRow.count += count;
          } else {
            sumData.push({label, count});
          }
        }
      }

      // sumData를 count로 정렬한다
      sumData.sort((a, b) => b.count - a.count);


      const list = [];
      let no = 1;

      for (const row of sumData) {
        list.push({
          label: row.label,
          value: row.count,
        });
        no += 1;

        if (no > 5) break;
      }

      this.total = parseInt(data.monthly[currentYear][0]);
      this.data = list;
    },
    onClickDetail () {
      const projectId = this.$route.params.proj_id
      const graphId = this.graphId
      if (projectId) {
        this.$router.push(`/project/${projectId}/graph-detail/${graphId}`)
      } else {
        this.$router.push(`/graph-detail/${graphId}`)
      }
    },
    onClickWrite () {
      const proj_id = this.$route.params.proj_id
      const boardId = `${this.boardId}`
      this.$router.push({name: 'write|tab', params: {proj_id, boardId}})
    }
  },
}
</script>

<style scoped>

</style>
